import React, { useState } from "react";
import { colors } from "../utils/theme.js";
import { inputStyle, primaryBtn, ghostBtn, editBtn } from "./ui.js";

const row = { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, padding: "11px 0", borderBottom: `1px solid ${colors.border}` };
const lab = { fontSize: 11, textTransform: "uppercase", letterSpacing: 0.6, color: colors.textDim, width: 150, flexShrink: 0, paddingTop: 2 };

// Read-first field: renders the value with an Edit control; Edit reveals an inline editor.
// onSave(draft) persists and may return false to keep the editor open (validation/failure).
export default function TextField({ label, value, onSave, multiline, placeholder, isLink }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    const r = await onSave(draft.trim());
    setBusy(false);
    if (r !== false) setEditing(false);
  };

  if (editing) {
    const Tag = multiline ? "textarea" : "input";
    return (
      <div style={row}>
        <div style={lab}>{label}</div>
        <div style={{ flex: 1 }}>
          <Tag autoFocus value={draft} placeholder={placeholder}
            style={{ ...inputStyle, ...(multiline ? { minHeight: 54, resize: "vertical" } : {}) }}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => { if (!multiline && e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }} />
          <div style={{ marginTop: 6, display: "flex", gap: 8 }}>
            <button disabled={busy} onClick={save} style={primaryBtn}>{busy ? "Saving…" : "Save"}</button>
            <button onClick={() => setEditing(false)} style={ghostBtn}>Cancel</button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div style={row}>
      <div style={lab}>{label}</div>
      <div style={{ flex: 1, fontSize: 13.5, color: value ? colors.text : colors.textDim, whiteSpace: multiline ? "pre-wrap" : "normal", wordBreak: "break-word" }}>
        {value ? (isLink ? <a href={value} target="_blank" rel="noreferrer" style={{ color: colors.accent, textDecoration: "none" }}>{value} ↗</a> : value) : (placeholder || "—")}
      </div>
      <button onClick={() => { setDraft(value || ""); setEditing(true); }} style={editBtn}>Edit</button>
    </div>
  );
}
